<template>
    <div v-wechat-title="title" class="padding10">
        <el-row v-if="active_item.item_code" class="padding5">
            <el-col :span="18" class="align-left">
                <h3 class="margin-none-v">{{ active_item.item_name }}</h3>
            </el-col>
            <el-col :span="6" class="align-right">
                <el-button type="warning" size="mini" @click="SaveChanges"><i class="el-icon-loading" v-if="!finished"></i>保存</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="18" :md="16" v-if="this.surgeryId" style="overflow: hidden">
                <DocFrame
                    :docbizid.sync="active_item.docbizid"
                    ref="doc"
                    :style="{ height: `${this.screenHeight - 340}px` }"
                    :docno="(this.$root.DOCUMENT && this.$root.DOCUMENT[this.active_item.item_code]) || 0"
                    :surgeryId="surgeryId"
                    :docname="active_item.item_name || ''"
                    @saved="afterDocSaved"
                ></DocFrame>
            </el-col>
            <el-col :lg="18" :md="16" v-else>
                <p class="no-surgery">暂无手术</p>
            </el-col>
            <el-col :lg="6" :md="8">
                <div class="item" :class="{ active: active_item.item_code == item.item_code }" v-for="item in scoreItems" :key="item.item_code" @click="ActiveItem(item)">
                    <el-row>
                        <el-col :span="20">{{ item.item_name }}</el-col>
                        <el-col :span="4"
                            ><el-tag effect="dark" style="color: #ffffff" :type="item.level || 'info'" size="small" v-if="item.result">{{ item.result }}</el-tag></el-col
                        >
                    </el-row>
                    <div v-if="item.result" class="font-size12">
                        {{ $moment(item.modify_date).format('YYYY/MM/DD HH:mm') }}&nbsp;&nbsp;{{ item.modifier }}&nbsp;&nbsp;
                        <el-button
                            v-if="active_item.item_code == item.item_code"
                            type="danger"
                            icon="el-icon-delete"
                            circle
                            size="mini"
                            style="padding: 4px"
                            plain
                            @click.stop="deleteDoc(item)"
                        ></el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: `Score2`,
    props: {

    },
    data() {
        return {
            title: `评分`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            items: [{ item_code: `PF015`, item_name: `GCS格拉斯哥昏迷评分` },
                { item_code: `PF016`, item_name: `全麻steward复苏评分` },
                { item_code: `PF017`, item_name: `压疮危险因素Braden评分` },
                { item_code: `PF018`, item_name: `创伤TS评分` },
                { item_code: `PF019`, item_name: `ASA病情分级` },
                { item_code: `PF020`, item_name: `肺功能减退分级` }],
            active_item: {},
            finished: true,
            docbizid: ``,
            scoreItems: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`])

    },
    mounted() {
        this.loadScore()
    },
    methods: {
        ActiveItem(item) {
            this.active_item = item
            this.docbizid = ``
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            this.finished = true
            this.loadScore()
        },
        SaveChanges() {
            if (this.finished) {
                this.finished = false
                this.$refs.doc.save()
                this.loadScore()
            }
        },
        loadScore() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Nursing/Score/Get?surgeryId=${this.surgeryId}`)
            req.then(data => {
                let r = _.map(this.items, d => {
                    let f = _.find(data, { document_name: d.item_code })
                    let level = `info`
                    if (f) {
                        switch (d.item_code) {
                        case `PF015`:level = f.result >= 12 ? `info` : f.result >= 9 ? `warning` : `danger`; break
                        }
                    }
                    return Object.assign({ level: level, docbizid: f && f.document_id }, d, f || {})
                })
                this.scoreItems = r
                if (!_.has(this.active_item, `item_code`)) {
                    this.ActiveItem(r[0])
                }
            }).catch(e => console.log(e))
        },
        deleteDoc(item) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/DeleteInstance`,
                    { headers: { 'content-type': `application/x-www-form-urlencoded` },
                        params: { docbizid: this.docbizid, operator: this.currentUser.dic_worker_id } })
                let req2 = this.myaxios.delete(`/api/Nursing/Score/Delete/${item.id}`)
                this.myaxios.all(req, req2).then(([data, d2]) => {
                    this.active_item = {}
                    this.loadScore()
                })
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.active_item = {}
            this.loadScore()
        }
    }
}
</script>
<style scoped lang="less">
.item {
    margin: 0 5px 5px;
    text-align: left;
    background: whitesmoke;
    padding: 10px;
    cursor: pointer;
    &.active {
        background: darkgray;
        color: whitesmoke;
    }
}
.el-tag--dark {
    &.el-tag--info {
        background-color: #909399;
        border-color: #909399;
    }
    &.el-tag--danger {
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    &.el-tag--warning {
        background-color: #e6a23c;
        border-color: #e6a23c;
    }
    &.el-tag--success {
        background-color: #67c23a;
        border-color: #67c23a;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Score/Index.vue